// Production is the default even when the UI runs locally. A local backend is opt-in.
export const TALENT_API_BASE = (
  process.env.REACT_APP_TSE_API_BASE_URL ||
  (process.env.NODE_ENV === 'development' && process.env.REACT_APP_API_BASE_URL_LOCAL) ||
  'https://talent-search-backend-435586021357.us-central1.run.app/api'
).replace(/\/$/, '');

// Cloud Run can take ~40 seconds to start after sitting idle. Keep the balance
// request alive long enough for that first startup, then retry transient errors.
const CREDIT_READ_TIMEOUT_MS = 75000;

async function readAccount(path, uid) {
  const url = `${TALENT_API_BASE}/${path}?user_uid=${encodeURIComponent(uid)}`;
  for (let attempt = 0; attempt < 2; attempt += 1) {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), CREDIT_READ_TIMEOUT_MS);
    try {
      const response = await fetch(url, { signal: controller.signal });
      if (response.ok) return await response.json();
      // A bad request or denied access cannot be repaired by retrying.
      if (response.status < 500 && response.status !== 408 && response.status !== 429) break;
    } catch (error) {
      if (attempt === 1) throw error;
    } finally {
      clearTimeout(timeout);
    }
  }
  throw new Error('Could not load your credits. Please try again.');
}

export async function loadTalentCredits(uid, subscriptionUnlimited = false) {
  if (subscriptionUnlimited) return { unlimited: true, remaining: 999999, analysis: 999999 };
  // Unlimited records are server-readable only. Do not read them with the browser
  // Firebase SDK or loosen database rules to expose billing/entitlement records.
  const subscription = await readAccount('check_subscription', uid);
  if (subscription.unlimited === true) return { unlimited: true, remaining: 999999, analysis: 999999 };
  const data = await readAccount('credits', uid);
  const count = value => Math.max(0, Number(value) || 0);
  return { unlimited: false,
    remaining: count(data.monthlyCredits) + count(data.purchasedCredits),
    analysis: data.analysisCredits == null ? 20 : count(data.analysisCredits) };
}
